// extracted by mini-css-extract-plugin
export default {"noDataTile":"no-data-tile_noDataTile__LknB3"};